import request from 'local_modules/request'
import { constants, getYMD } from 'helpers'
import { reducers, getState } from 'redux/core'
import moment from 'moment'


const setFetching = (isFetching) => reducers.marketplace.adminReportPage.setFetching(isFetching)

const fetchTrainers = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentTrainer + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setTrainers(data))
    .catch((error) => console.log(error))
}

const fetchStatistic = ({ from, to }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.statisticLearn + `/${tool}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticSubscribers = ({ from, to, patterns = [] }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.statisticSubscribers + `/${tool}`, {
    patterns,
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticTrainer = ({ from, to, trainerId = '' }) => {
  return request.post(constants.marketplace.statisticLearn + `/${trainerId}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticPayment = ({ from, to }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.statisticPayment + `/${tool}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticLearning = ({ from, to }) => {
  const { marketplace: { layersNavigation: { area } } } = getState()

  return request.post(constants.marketplace.statisticLearning + `/${area}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticPaymentSuccess = ({ from, to }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.statisticPaymentSuccess + `/${tool}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticServices = ({ from, to }) => {
  const { marketplace: { layersNavigation: { tool, area } } } = getState()

  return request.post(constants.marketplace.statisticPaymentSuccess + `/${tool}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => {
      const { subscriptions, total } = data

      const items = {
        subscriptions: [],
      }

      const itemsTotal = {
        subscriptions: 0,
      }

      subscriptions.forEach(({ usages, ts, canceledAt, tariffCategory = {} }) => {
        if (usages) {
          usages.forEach(({ services, payed }) => {
            items.subscriptions.push({
              date: moment(ts).format('DD.MM.YYYY HH:mm'),
              payed,
              canceledAt: canceledAt ? moment(canceledAt).format('DD.MM.YYYY HH:mm') : '',
              tariffCategoryName: tariffCategory.name,
            })

            if (!canceledAt) {
              itemsTotal.subscriptions = itemsTotal.subscriptions + payed
            }

            if (services && services.length) {
              services.forEach(({ id, title, payed, price, quantity }) => {
                if (items[title]) {
                  items[title].push({
                    quantity,
                    date: moment(ts).format('DD.MM.YYYY HH:mm'),
                    payed,
                    canceledAt: canceledAt ? moment(canceledAt).format('DD.MM.YYYY HH:mm') : '',
                    tariffCategoryName: tariffCategory.name,
                  })

                  if (!canceledAt) {
                    itemsTotal[title] = itemsTotal[title] + (payed * quantity)
                  }
                }
                else {
                  items[title] = [{
                    quantity,
                    date: moment(ts).format('DD.MM.YYYY HH:mm'),
                    payed,
                    canceledAt: canceledAt ? moment(canceledAt).format('DD.MM.YYYY HH:mm') : '',
                    tariffCategoryName: tariffCategory.name,
                  }]

                  itemsTotal[title] = canceledAt
                    ? 0
                    : payed * quantity
                }
              })
            }
          })
        }
      })

      return reducers.marketplace.adminReportPage.setStatistic({
        items,
        total,
        itemsTotal,
      })
    })
    .catch((error) => console.log(error))
}

const fetchFullTool = ({ from, to }) => {
  const { marketplace: { layersNavigation: { tool, area } } } = getState()

  return request.post(constants.marketplace.statisticFullTool + `/${area}`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}

const fetchStatisticPaymentByDateSuccess = ({ from, to }) => {
  const { marketplace: { layersNavigation: { tool, area } } } = getState()

  return request.post(constants.marketplace.statisticFullTool + `/${area}` + `/byDate`, {
    fromInt: getYMD(from),
    toInt: getYMD(to),
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportPage.setStatistic(data))
    .catch((error) => console.log(error))
}


export default {
  setFetching,

  fetchFullTool,
  fetchTrainers,
  fetchStatistic,
  fetchStatisticLearning,
  fetchStatisticSubscribers,
  fetchStatisticTrainer,
  fetchStatisticPayment,
  fetchStatisticPaymentSuccess,
  fetchStatisticPaymentByDateSuccess,
  fetchStatisticServices,
}
